var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs-layout"},_vm._l((_vm.breadcrumbs),function(item){return _c('div',{key:item.path,staticClass:"breadcrumbs-block",class:{ 'disabled-link': _vm.$route.name === item.name },on:{"click":function($event){return _vm.goTo(item)}}},[_vm._v(" "+_vm._s(_vm.translateBreadcrumb(item.name))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }